const TRACKING_CATEGORY = {
  breadcrumb: 'breadcrumbLinkClicked',
  footer: 'footerLinkClicked',
  header: 'headerLinkClicked',
}

const linkClicked = (type, link) => {
  const event = TRACKING_CATEGORY[type]
  return ({
    [type]: {
      subject: { link, url: document.referrer },
    },
    event,
  })
}

export default linkClicked
